/* eslint-disable camelcase */
const candidateAvailabilityTranslations = {
    en: {
        pageHeading: 'Update availability',
        asideTitle: 'Select days',
        daysSelected_one: '{{count}} day selected',
        daysSelected_other: '{{count}} days selected',
        updatedSuccessfully: 'Successfully updated',
        assistiveText: 'By updating your availability and working time preferences, you help us to find more suitable assignments for you.\n\nFor specific days, click \'Short term\' and select the days you want to work or are unavailable. If you want to specify your availability for a longer period, please click \'Long term\' and select the start and end date of your availability (or unavailability).',
        timeSlotStatus: {
            Available: 'Available',
            Unavailable: 'Unavailable',
            Partial: 'Partial',
            Unknown: 'Unknown'
        },
        timeSlotClear: 'Clear',
        timeSlotUnavailableAllDay: 'Unavailable all day',
        timeSettingsFieldUnknownDescription: 'Clear availability details',
        backToOpportunities: 'Opportunities',
        updateAvailabilityBtn: 'Update availability',
        mode: {
            calendar: 'Short term',
            range: 'Long term'
        },
        range: {
            heading: 'Set availability range',
            startDate: 'Start date',
            endDate: 'End date',
            startTime: 'Start time',
            endTime: 'End time',
            submit: 'Apply',
            useCalendarHint: 'Or use calendar to pick specific dates',
            validation: {
                startAfterEnd: 'Start date must be before or equal to end date'
            },
            addNewTitle: 'Add new period',
            existingPeriodsTitle: 'Existing periods',
            noPeriods: 'No availability periods have been set.',
            update: 'Update',
            cancel: 'Cancel',
            edit: 'Edit',
            delete: 'Delete'
        },
        updateAvailabilityForm: {
            submit: 'Save',
            cancel: 'Cancel',
            addTimeSlot: 'Add time slot',
            timeSlotsTitle: 'Time (optional)',
            timeSlotTitlePrompt: 'If the "To" time is earlier than the "From" time, the availability extends to the next day',
            placeholderFrom: 'From',
            placeholderTo: 'To'
        },
        submit: 'Submit',
        weekShort: 'W',
        dialog: {
            send: {
                description: 'Press "Confirm" to submit your availability.',
                cancel: 'Cancel',
                confirm: 'Confirm'
            }
        },
        onboarding: {
            dismiss: 'Dismiss',
            next: 'Next',
            gotIt: 'Got it',
            startNew: {
                title: 'Hints & tips',
                description: 'Let us show you some ideas on how to update your availability faster',
                submit: 'Get started'
            },
            steps: {
                selectAll: 'Click here to choose all the dates presented',
                weekday: 'Or choose a specific day during this period by clicking here',
                week: 'You can select the whole week here',
                timeSlot: 'Set your availability by selecting one of the options above'
            }
        },
        selectedDatesJobInfo: {
            title: 'Approved Shifts',
            subtitle: '{{count}} days selected',
            subtitle_one: '{{count}} day selected',
            view: 'View'
        }
    },
    no: {
        pageHeading: 'Oppdater tilgjengelighet',
        daysSelected_one: '{{count}} dag valgt',
        daysSelected_other: '{{count}} dager valgt',
        updatedSuccessfully: 'Oppdatering vellykket',
        assistiveText: 'Når du oppdaterer tilgjengeligheten din og preferansene dine for arbeidstid, hjelper du oss med å finne mer passende oppdrag for deg.\n\nFor enkelt­dager: klikk «Kortsiktig» og velg dagene du vil jobbe, eller er utilgjengelig. Hvis du vil angi tilgjengeligheten din for en lengre periode: klikk «Langsiktig» og velg start- og sluttdato for når du er tilgjengelig (eller utilgjengelig).',
        timeSlotClear: 'Tøm',
        timeSlotStatus: {
            Available: 'Tilgjengelig',
            Unavailable: 'Utilgjengelig',
            Partial: 'Delvis',
            Unknown: 'Ukjent'
        },
        timeSlotUnavailableAllDay: 'Utilgjengelig hele dagen',
        timeSettingsFieldUnknownDescription: 'Slett tilgjengelighetsdetaljer',
        updateAvailabilityBtn: 'Oppdater tilgjengelighet',
        mode: {
            calendar: 'Kortsiktig',
            range: 'Langsiktig'
        },
        range: {
            heading: 'Angi tilgjengelighetsperiode',
            startDate: 'Startdato',
            endDate: 'Sluttdato',
            startTime: 'Starttid',
            endTime: 'Sluttid',
            submit: 'Bruk',
            useCalendarHint: 'Eller bruk kalender for å velge spesifikke datoer',
            validation: {
                startAfterEnd: 'Startdato må være før eller lik sluttdato'
            },
            addNewTitle: 'Legg til ny periode',
            existingPeriodsTitle: 'Eksisterende perioder',
            noPeriods: 'Ingen tilgjengelighetsperioder er angitt.',
            update: 'Oppdater',
            cancel: 'Avbryt',
            edit: 'Rediger',
            delete: 'Slett'
        },
        asideTitle: 'Velg dager',
        backToOpportunities: 'Oppdrag',
        updateAvailabilityForm: {
            submit: 'Lagre ',
            cancel: 'Avbryt',
            addTimeSlot: 'Legg til flere tidsperioder',
            timeSlotsTitle: 'Tid (valgfritt)',
            timeSlotTitlePrompt: 'Hvis "Til"-tiden er tidligere enn "Fra"-tiden, utvides tilgjengeligheten til neste dag',
            placeholderFrom: 'Fra',
            placeholderTo: 'Til'
        },
        submit: 'Sende inn',
        weekShort: 'U',
        dialog: {
            send: {
                description: 'Trykk "Godkjenn" får sende inn din tilgjengelighet.',
                cancel: 'Avbryt',
                confirm: 'Godkjenn' 
            } 
        },
        onboarding: {
            dismiss: 'Avvis',
            next: 'Neste',
            gotIt: 'Skjønner',
            startNew: {
                title: 'Brukerguide',
                description: 'La oss vise deg hvordan du oppdaterer din tilgjengelighet',
                submit: 'Kom i gang' 
            },
            steps: {
                selectAll: 'Klikk her for å velge alle datoene',
                weekday: 'Eller velg en spesifikk dag i perioden ved å klikke her',
                week: 'Her kan du velge en eller flere uker',
                timeSlot: 'Velg din tilgjengelighet med valgene over' 
            } 
        },
        selectedDatesJobInfo: {
            title: 'Godkjente vakter',
            subtitle: '{{count}} dager valgt',
            subtitle_one: '{{count}} dag valgt',
            view: 'Vis'
        }
    },
    sv: {
        pageHeading: 'Uppdatera tillgänglighet',
        daysSelected_one: '{{count}} dag vald',
        daysSelected_other: '{{count}} dagar valda',
        updatedSuccessfully: 'Uppdateringen lyckades',
        assistiveText: 'Genom att uppdatera din tillgänglighet och dina arbetstidspreferenser hjälper du oss att hitta mer passande uppdrag för dig.\n\nFör enskilda dagar: klicka på ”Kortsiktig” och välj dagarna du vill arbeta eller är otillgänglig. Om du vill ange din tillgänglighet för en längre period: klicka på ”Långsiktig” och välj start- och slutdatum för när du är tillgänglig (eller otillgänglig).',
        timeSlotClear: 'Rensa',
        timeSlotStatus: {
            Available: 'Tillgänglig',
            Unavailable: 'Ej tillgänglig',
            Partial: 'Delvis',
            Unknown: 'Okänt'
        },
        timeSlotUnavailableAllDay: 'Ej tillgänglig hela dagen',
        timeSettingsFieldUnknownDescription: 'Rensa tillgänglighetsdetaljer',
        updateAvailabilityBtn: 'Uppdatera tillgänglighet',
        mode: {
            calendar: 'Kortsiktig',
            range: 'Långsiktigt'
        },
        range: {
            heading: 'Ange tillgänglighetsperiod',
            startDate: 'Startdatum',
            endDate: 'Slutdatum',
            startTime: 'Starttid',
            endTime: 'Sluttid',
            submit: 'Verkställ',
            useCalendarHint: 'Eller använd kalendern för att välja specifika datum',
            validation: {
                startAfterEnd: 'Startdatum måste vara före eller lika med slutdatum'
            },
            addNewTitle: 'Lägg till ny period',
            existingPeriodsTitle: 'Befintliga perioder',
            noPeriods: 'Inga tillgänglighetsperioder har ställts in.',
            update: 'Uppdatera',
            cancel: 'Avbryt',
            edit: 'Redigera',
            delete: 'Ta bort'
        },
        asideTitle: 'Välj dagar',
        backToOpportunities: 'Uppdrag',
        updateAvailabilityForm: {
            submit: 'Spara',
            cancel: 'Avbryt',
            addTimeSlot: 'Lägg till fler tidsluckar',
            timeSlotsTitle: 'Tid (valfritt)',
            timeSlotTitlePrompt: 'Om "Till"-tiden är tidigare än "Från"-tiden, förlängs tillgängligheten till nästa dag',
            placeholderFrom: 'Från',
            placeholderTo: 'Till'
        },
        submit: 'Skicka',
        weekShort: 'V',
        dialog: {
            send: {
                description: 'Tryck på "Bekräfta" för att skicka din tillgänglighet.',
                cancel: 'Avbryt',
                confirm: 'Bekräfta' 
            } 
        },
        onboarding: {
            dismiss: 'Avfärda',
            next: 'Nästa',
            gotIt: 'Jag förstår',
            startNew: {
                title: 'Tips och råd',
                description: 'Låt oss visa dig några idéer om hur du kan uppdatera din tillgänglighet snabbare',
                submit: 'Kom igång'
            },
            steps: {
                selectAll: 'Klicka här för att välja alla presenterade datum',
                weekday: 'Eller välj en specifik dag under denna period genom att klicka här',
                week: 'Du kan välja hela veckan här',
                timeSlot: 'Lägg in din tillgänglighet genom att välja ett av alternativen ovan'
            } 
        },
        selectedDatesJobInfo: {
            title: 'Godkända skift',
            subtitle: '{{count}} dagar valda',
            subtitle_one: '{{count}} dag vald',
            view: 'Visa'
        }
    } 
} as const;
export default candidateAvailabilityTranslations;
